export const dateTimeFormats = {
  short: {
    year: "numeric",
    month: "short",
    day: "numeric"
  },
  long: {
    year: "numeric",
    month: "short",
    day: "numeric",
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: false
  }
};

export default {
  about_directus: "O aplikaci Directus",
  activity: "Aktivity",
  my_activity: "Moje aktivity",
  activity_log: "Záznam aktivit",
  activity_outside_directus: "Tato položka byla vytvořena mimo administraci.",
  admin_email: "Email admina",
  admin_password: "Heslo admina",
  additional_info: "Dodatečné informace",
  add_new: "Přidat nový",
  add_field_filter: "Přidat filtr na sloupec",
  add_note: "Přidat užitečné informace pro uživatele...",
  admin_settings: "Nastavení",
  all: "Vše",
  statuses: "Statusy",
  batch: "Dávka",
  batch_edit: "Hromadná úprava položek: {collection}",
  batch_delete: "Dávka smazána",
  batch_delete_confirm:
    "Nebyly vybrány žádné položky | Opravdu chcete smazat tuto položku? Operace je nevratná. | Jste si jist(a) smazáním těchto {count} položek? Operace je nevratná.",
  between: "Mezi",
  both: "Oboje",
  bookmarks: "Záložky",
  cancel: "Zrušit",
  choose_one: "Vybrat jeden",
  clear: "Vyčistit",
  connection: "Připojení",
  collection: "Kategorie",
  collection_updated: "Kategorie {collection} byla akatualizována",
  collection_removed: "Kategorie {collection} byla smazána",
  collection_names_cannot_be_changed:
    "Název kategorie nemůže být v současné chvíli změněn.",
  collections: "Kategorie",
  collection_count:
    "Žádné kategorie | Počet kategorií: 1 | Počet kategorií: {count}",
  "collections-directus_files": "Soubory",
  "collections-directus_users": "Uživatelé",
  "collections-directus_activity": "Aktivity",
  collection_contains_items: "{collection} obsahuje {count} položek",
  comment: "Komentář",
  comments: "Komentáře",
  contains: "Obsahuje",
  currently_selected: "Vybráno: {thing}",
  create: "Vytořit",
  creating_item: "Vytvořit položku",
  creating_item_page_title: "Vytvořit položku: {collection}",
  editing_my_profile: "Upravit můj profil",
  delete: "Smazat",
  delete_are_you_sure:
    "Opravdu chcete smazat tuto položku? Operace je nevratná.",
  description: "Popis",
  discard_changes: "Ano, odejít bez uložení",
  display_name: "Zobrazit jméno",
  drop_files:
    "Nelze přesunout soboury | Přesuňte soubor sem... | Přesuňte soubory sem...",
  dont_show: "Nezobrazovat",
  editing: "Úprava položky: {collection}",
  editing_item: "Úprava položky",
  editing_items: "Hromadná úprava {count} položek",
  editing_single: "Úprava {collection}",
  email_address: "Emailová adresa",
  email: "Email",
  empty_collection: "Kategorie je prázdná ",
  empty_collection_body: "V této kategorii ještě nejsou žádné položky",
  enable_manual_sorting: "Zapnout manuální řazení",
  enter_value: "Zadejte hodnotu",
  error_unknown: "Neznámá chyba. Zkuste to později.",
  esc_cancel: "Klávesa Escape zruší a zavře okno.",
  equal_to: "Je rovno",
  existing: "Vybrat existující",
  field: "Sloupec",
  fields: "Sloupce",
  fields_are_saved_instantly: "Změny jsou ukládány okamžitě",
  file: "Soubor",
  file_library: "Složka souborů",
  file_upload: "Nahrát soubor(y)",
  forgot_password: "Zapomenuté heslo",
  greater_than_equal: "Větší nebo rovno než",
  greater_than: "Větší než",
  help_and_docs: "Nápověda",
  keep_editing: "Ne, vrátit se k úpravám",
  item_count: "Bez výsledků | Jeden výsledek | Výsledků: {count}",
  item_count_filter:
    "Žádná vyfiltrová položka | Jedna vyfiltrová položka | {count} vyfiltrovaných položek",
  item_deleted: "Položka smazána",
  item_saved: "Položka uložena | Uloženo položek: {count}",
  latency: "Latence",
  learn_more: "Zjistit více",
  leave_comment: "Napsat komentář...",
  length: "Délka",
  less_than_equal: "Méně nebo rovno než",
  less_than: "Méně než",
  limited: "Omezeno",
  loading: "Nahrávám...",
  loading_more: "Náhrávám více položek...",
  login: "Přihlásit",
  name: "Jméno",
  navigate_changes: "Pokud opustíte stránku Vaše úpravy budou ztraceny",
  new: "Nový",
  new_file: "Nový soubor",
  no_results: "Bez výsledků",
  no_results_body: "Podle zadaných filtrů nebyly nalezeny žádné položky",
  no_files: "Bez souborů",
  page_not_found: "Stránka nenalezena",
  page_not_found_body: "Hledaná stránka nebyla nalezena.",
  name_bookmark: "Jak chcete pojmenovat tuto záložku?",
  next: "Další",
  not_equal_to: "Nerovná se",
  manage: "Upravit",
  max_size: "Max. velikost: {size}",
  my_profile: "Můj profil",
  other: "Další",
  ok: "OK",
  password: "Heslo",
  password_reset_sent: "Email pro obnovení hesla odeslat na {email}",
  remove: "Odebrat",
  reset_password: "Obnovit heslo",
  revert_copy: "Opravdu chcete vrátit veškeré změny této položky k {date}?",
  save: "Uložit",
  save_and_add: "Uložit a přidat další",
  save_and_stay: "Uložit a zůstat",
  save_as_copy: "Uložit jako kopii",
  save_as_bookmark: "Uložit jako záložku",
  search: "Vyhledat",
  select_existing: "Vybrat z uložených",
  select_field: "Vybrat položky",
  settings: "Nastavení",
  sign_in: "Přihlásit se",
  signing_in: "Přihlašuji",
  sign_out: "Odhlásit se",
  sign_out_confirm: "Chcete se odhlásit?",
  sign_out_confirm_edits:
    "Opravdu se chcete odhlásit? Všechny neuložené změny budou ztraceny.",
  unsaved_changes_copy: "Máte neuložené změny. Opravdu chcete opustit stránku?",
  user_directory: "Uživatelé",
  update_confirm: "Opravdu chcete aktualizovat {count} položek?",
  view_type: "Zobrazit jako...",
  welcome: "Vítejte",
  yes: "Ano"
};
